import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ERROR, MAIN, SUB, SERVICE_IDS } from '../../../constants/elements';
import filterServices from '../../../utils/filterServices';
import NOB from '../../../constants/language-strings';
import remove360FromServiceType from '../../../utils/remove360FromServiceType';
import setCategoryDropdown from '../../../utils/setCategoryDropdown';
import subMainErrorCategoryValues from '../../../utils/subMainErrorCategoryValues';
import selectDiagnosticServiceUtil from '../../../utils/selectDiagnosticService';
import { CATEGORY_SUB } from '../addServiceCodeConstants';
import hideSelectedDiagnosticServices from '../../../utils/hideSelectedDiagnosticServices';
import setDiagnosisCategoryDropdown from '../../../utils/setDiagnosisCategoryDropdown';
import AddServiceCategoryPicker from '../components/AddServiceCategoryPicker';
import '../addService.scss';
import * as updateServiceAction from '../../WorkLog/actions/updateServiceActions';
import { TECHNICIAN } from '../../Authentication/constants';
import SimpleButton from '../../../components/Buttons/SimpleButton/SimpleButton';
import Color from '../../../components/Buttons/Color';
import AddServiceListSearch from '../components/AddServiceListSearch';
import renderService from '../components/content/RenderService';
import objectNameComparator from '../../../utils/objectNameComparator';
import { SlideInModal } from 'components/slide-in-modal';
const AddServiceCodeContainer = ({ addServiceCode = false, workOrderServices, workOrderId = 0, diagnosticServices = [], findServices, loadTimeSlots = null, requestUpdateService = null, role, selectedDiagnosticServices = [], serviceType = {}, serviceTypes = [], updateDiagnosticServices = null, }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showMainCategories, setShowMainCategories] = useState(false);
    const [showSubCategories, setShowSubCategories] = useState(false);
    const [showMainErrors, setShowMainErrors] = useState(false);
    const [mainCategory, setMainCategory] = useState('');
    const [subCategory, setSubCategory] = useState('');
    const [mainError, setMainError] = useState('');
    const toggleModal = () => {
        resetCategories();
        setIsModalOpen(prev => !prev);
    };
    const resetCategories = () => {
        setShowMainCategories(false);
        setShowSubCategories(false);
        setShowMainErrors(false);
        setMainCategory('');
        setSubCategory('');
        setMainError('');
    };
    const toggleCategoryDropdown = type => {
        setShowMainCategories(type === MAIN ? !showMainCategories : false);
        setShowSubCategories(type === SUB ? !showSubCategories : false);
        setShowMainErrors(type === ERROR ? !showMainErrors : false);
    };
    const selectedCategory = ({ name }) => {
        const { subCategoryValue, mainErrorValue } = subMainErrorCategoryValues(showSubCategories, showMainErrors, name, subCategory, mainError);
        setShowMainCategories(false);
        setShowSubCategories(showMainCategories);
        setShowMainErrors(showSubCategories);
        if (showMainCategories)
            setMainCategory(name);
        setSubCategory(subCategoryValue);
        setMainError(mainErrorValue);
    };
    const filteredServiceTypes = useCallback(list => {
        const { name } = serviceType;
        return list.filter(service => remove360FromServiceType(service.serviceType) === name);
    }, [serviceType]);
    const handleSelectedDiagnosticService = event => {
        const selectedType = filteredServiceTypes(diagnosticServices)[0].services.filter(service => service.serviceId === event.value);
        const newSelected = selectedDiagnosticServices.concat(selectDiagnosticServiceUtil(selectedType));
        updateDiagnosticServices(newSelected);
        loadTimeSlots(SERVICE_IDS, newSelected.map(service => service.serviceId));
        toggleModal();
    };
    const addServiceCodeFn = service => {
        const serviceId = service.id;
        const quantity = 1;
        const shouldAdd = true;
        requestUpdateService(workOrderId, serviceId, quantity, shouldAdd);
        toggleModal();
    };
    const categories = category => {
        const { services } = findServices;
        const allCategories = filterServices(services, workOrderServices, true, !addServiceCode);
        const values = setCategoryDropdown(category, allCategories, mainCategory, subCategory);
        return values.filter(value => value.name);
    };
    const diagnosisCategories = category => {
        const filtered = filteredServiceTypes(serviceTypes);
        let values = setDiagnosisCategoryDropdown(category, filtered, mainCategory, subCategory);
        if (category === CATEGORY_SUB) {
            values = hideSelectedDiagnosticServices(values, selectedDiagnosticServices, true);
        }
        return values.filter(value => value.name);
    };
    const technician = role === TECHNICIAN;
    const diagnosticServiceList = () => {
        const values = [];
        filteredServiceTypes(diagnosticServices).map(diag => diag.services.map(service => values.push(service)));
        return hideSelectedDiagnosticServices(values, selectedDiagnosticServices, false);
    };
    const serviceList = filterServices(findServices.services, workOrderServices, false, !addServiceCode);
    const addServiceProps = addServiceCode
        ? {
            categories,
            selectService: addServiceCodeFn,
            serviceList,
        }
        : {
            categories: diagnosisCategories,
            selectService: handleSelectedDiagnosticService,
            serviceList: diagnosticServiceList(),
        };
    const filteredServices = filterServices(addServiceProps.serviceList, workOrderServices, true, !addServiceCode)
        .filter(service => (mainCategory === '' || service.main === mainCategory) &&
        (subCategory === '' || service.sub === subCategory) &&
        (mainError === '' || service.error === mainError))
        .sort(objectNameComparator);
    const modalText = addServiceCode
        ? NOB.ADD_SERVICE.ADD_NEW_SERVICE
        : NOB.CREATE_NEW_WORK_ORDER.ADD_DIAGNOSIS;
    return (_jsxs("div", { className: "add__service", children: [_jsx("div", { className: !addServiceCode ? 'add_diagnosis_button' : 'add_service_button', id: "openModal", children: _jsx(SimpleButton, { onClick: toggleModal, title: modalText, color: Color.BLACK }) }), _jsx(SlideInModal, { display: isModalOpen, onClose: toggleModal, mainHeading: modalText, cleanUp: () => { }, children: _jsxs("div", { className: `transparent_background_container ${showMainCategories ||
                        showSubCategories ||
                        (showMainErrors && filteredServices.length > 1)
                        ? 'open_transparent_background'
                        : ''}`, children: [_jsx("div", { className: "add__service", children: _jsx(AddServiceCategoryPicker, { categories: addServiceProps.categories, mainCategory: mainCategory, mainError: mainError, resetCategories: resetCategories, technician: technician, selectedCategory: selectedCategory, showMainCategories: showMainCategories, showMainErrors: showMainErrors, showSubCategories: showSubCategories, subCategory: subCategory, toggleCategoryDropdown: toggleCategoryDropdown }) }), _jsx("div", { className: "hide_overflow", children: _jsx(AddServiceListSearch, { placeholder: NOB.ADD_SERVICE.SEARCH, onChange: addServiceProps.selectService, options: filteredServices, renderOption: renderService }) })] }) })] }));
};
AddServiceCodeContainer.propTypes = {
    addServiceCode: PropTypes.bool,
    diagnosticServices: PropTypes.arrayOf(PropTypes.any),
    findServices: PropTypes.objectOf(PropTypes.any).isRequired,
    loadTimeSlots: PropTypes.func,
    requestUpdateService: PropTypes.func,
    role: PropTypes.string.isRequired,
    selectedDiagnosticServices: PropTypes.arrayOf(PropTypes.any),
    serviceType: PropTypes.objectOf(PropTypes.any),
    serviceTypes: PropTypes.arrayOf(PropTypes.any),
    updateDiagnosticServices: PropTypes.func,
    workOrderId: PropTypes.number,
    workOrderServices: PropTypes.arrayOf(PropTypes.any).isRequired,
};
const mapStateToProps = state => ({
    findServices: state.findServices,
    role: state.authentication.role,
});
const mapDispatchToProps = dispatch => ({
    requestUpdateService: (workOrderId, serviceId, quantity, added) => dispatch(updateServiceAction.requestUpdateService({
        workOrderId,
        serviceId,
        quantity,
        added,
    })),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddServiceCodeContainer);
